import React, { useEffect } from 'react';
import { Award, Calendar, FileText, Code } from 'lucide-react';
import { useData } from '../context/DataContext';

const Authors = () => {
  const { scripts, articles, faqs, trackPageView } = useData();

  useEffect(() => {
    trackPageView('authors');
  }, [trackPageView]);

  const authors = [
    {
      id: 1,
      name: 'Suresh Kumar Reddy',
      title: 'Senior Database Administrator & Founder',
      experience: '12+ Years',
      specialization: 'Performance Tuning, High Availability, Security',
      bio: 'Founder of MSSQLDBATeam.com with over 12 years of SQL Server administration experience. Specialized in performance optimization, disaster recovery, and enterprise database management.',
      image: '/myprofile.png',
      contributions: {
        scripts: scripts.filter(s => s.author === 'MSSQLDBATeam' || s.author === 'Suresh Kumar Reddy' || !s.author).length,
        articles: articles.filter(a => a.author === 'MSSQLDBATeam' || a.author === 'Suresh Kumar Reddy' || !a.author).length,
        faqs: faqs.filter(f => f.author === 'MSSQLDBATeam' || f.author === 'Suresh Kumar Reddy' || !f.author).length
      }
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Our Authors</h1>
        <p className="page-description">
          Meet the experienced SQL Server professionals who contribute to MSSQLDBATeam.com.
        </p>
      </div>

      <div className="authors-grid">
        {authors.map(author => (
          <div key={author.id} className="author-card">
            <div className="author-header">
              <img src={author.image} alt={author.name} className="author-image" />
              <div className="author-info">
                <h3 className="author-name">{author.name}</h3>
                <p className="author-title">{author.title}</p>
                <div className="author-experience">
                  <Award size={16} />
                  <span>{author.experience}</span>
                </div>
              </div>
            </div>
            
            <div className="author-specialization">
              <strong>Specialization:</strong> {author.specialization}
            </div>
            
            <p className="author-bio">{author.bio}</p>
            
            <div className="author-contributions">
              <h4>Contributions</h4>
              <div className="contributions-grid">
                <div className="contribution-item">
                  <Code size={20} color="#28a745" />
                  <span>{author.contributions.scripts} Scripts</span>
                </div>
                <div className="contribution-item">
                  <FileText size={20} color="#17a2b8" />
                  <span>{author.contributions.articles} Articles</span>
                </div>
                <div className="contribution-item">
                  <Calendar size={20} color="#ffc107" />
                  <span>{author.contributions.faqs} FAQ</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="join-authors">
        <h2>Want to Contribute?</h2>
        <p>
          We're always looking for experienced SQL Server professionals to share their knowledge. 
          If you have valuable scripts, articles, or insights to contribute, we'd love to hear from you.
        </p>
        <div className="contact-info">
          <p>Contact us at <a href="mailto:contact@mssqldbateam.com">contact@mssqldbateam.com</a> to become a contributing author!</p>
          <p><strong>Note:</strong> You can add new authors through the Admin Panel → User Management section.</p>
        </div>
      </div>
    </div>
  );
};

export default Authors;